import shortid from 'shortid';

const initialState = {
  modals: [],
};

export default function app(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    // MODAL
    case 'APP_MODAL_OPEN':
      return {
        ...state,
        modals: [
          ...state.modals,
          {
            ...payload,
            id: shortid.generate(),
          },
        ],
      };

    case 'APP_MODAL_CLOSE': {
      let newModals = [];

      if (payload !== 'all') {
        newModals = [...state.modals];
        newModals.pop();
      }

      return {
        ...state,
        modals: newModals,
      };
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./js/reducers/app.js